import { render } from "./SerieIndex.vue?vue&type=template&id=3cf15eea"
import script from "./SerieIndex.vue?vue&type=script&lang=js"
export * from "./SerieIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__